import * as yup from 'yup';
import { differenceInDays } from 'date-fns';

const ABN_RX = /^(?:\d\s?){11}$/;
const PHONE_NUMBER_RX = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
const QFF_NUMBER_RX = /^(?:\d{7}|\d{10})$/;

export const schema = yup.object({
  name: yup.string().notRequired(),
  email: yup.string().trim().email('Please enter a valid email address').required('Email is required').label('Email address').max(255),
  phoneNumber: yup
    .string()
    .trim()
    .required('Phone is required')
    .label('Phone number')
    .max(40)
    .test('phoneNumber', 'Please enter a valid phone number', (phoneNumber) => !phoneNumber || PHONE_NUMBER_RX.test(phoneNumber)),
  qffNumber: yup
    .string()
    .trim()
    .label('ABN number')
    .test('qffNumber', 'Please enter a valid QFF number', (qffNumber) => !qffNumber || QFF_NUMBER_RX.test(qffNumber)),
  businessNumber: yup
    .string()
    .trim()
    .label('ABN number')
    .test('businessNumber', 'Please enter a valid ABN', (businessNumber) => !businessNumber || ABN_RX.test(businessNumber)),
});

export const isFourWeeksAfterCheckout = (checkoutDate) => {
  return differenceInDays(new Date(), new Date(checkoutDate)) >= 28;
};
